import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  iconMid: {
    padding: '5px',
    fontSize: 14
  },
  bigButton: {
    width: '100%',
    background: 'none',
    borderRadius: 0,
    padding: '10px 0',
    color: '#2196f3'
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({ classes, classStyle, label, onClickAction, disabled = false }) => {
    return (
      <Button
        className={classes.bigButton}
        onClick={() => {
          onClickAction();
        }}
        disabled={disabled}
      >
        <i className={`${classStyle} ${classes.iconMid}`} />
        <div className={classes.text}>{label}</div>
      </Button>
    );
  }
);

export default withStyles(styles)(button);
